import React from 'react';

const View = ({ width = 28, height = 28, fill = "#0058B8" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.0001 18.3127C16.3808 18.3127 18.3108 16.3828 18.3108 14.0021C18.3108 11.6214 16.3808 9.69141 14.0001 9.69141C11.6194 9.69141 9.68945 11.6214 9.68945 14.0021C9.68945 16.3828 11.6194 18.3127 14.0001 18.3127Z"
      fill={fill}
    />
    <path
      d="M27.5705 12.8075C24.257 8.80348 19.2413 4.94922 14.0001 4.94922C8.75776 4.94922 3.74086 8.80617 0.429583 12.8075C-0.143194 13.4994 -0.143194 14.5038 0.429583 15.1956C1.26208 16.2016 3.00735 18.1436 5.33834 19.8404C11.2089 24.1139 16.7783 24.1234 22.6618 19.8404C24.9928 18.1436 26.738 16.2016 27.5705 15.1956C28.1416 14.5051 28.1446 13.5017 27.5705 12.8075ZM14.0001 7.96668C17.3279 7.96668 20.035 10.6738 20.035 14.0016C20.035 17.3294 17.3279 20.0365 14.0001 20.0365C10.6722 20.0365 7.96514 17.3294 7.96514 14.0016C7.96514 10.6738 10.6722 7.96668 14.0001 7.96668Z"
      fill={fill}
    />
  </svg>
);

export default View;